'use client'

import { Button } from '@/components/button/button'
import oopsTextImage from '@/public/images/pngs/oops-text-image.png'
import { cn } from '@/utils/cn'

import '@/styles/globals.css'

export default function NotFound() {
  const handleGoHome = () => {
    window.location.href = '/'
  }

  return (
    <html lang="ko">
      <body
        className={cn(
          'h-exclusionHeaderDvh gap-40pxr px-20pxr flex w-full flex-col items-center justify-center',
          'mb:h-exclusionHeaderDvh2',
        )}
      >
        <h1
          style={{ backgroundImage: `url(${oopsTextImage.src})` }}
          className={cn(
            'text-200pxr bg-clip-text bg-center font-bold text-transparent drop-shadow-xl',
            'max700:text-120pxr',
            'mb:text-82pxr',
          )}
        >
          Oops!
        </h1>
        <p
          className={cn(
            'text-20pxr text-blueDark text-center font-normal',
            'max700:text-18pxr',
            'mb:text-16pxr',
          )}
        >
          404 PAGE NOT FOUND
          <br />
          <span className={cn('text-16pxr text-gray-500')}>
            요청하신 페이지를 찾을 수 없어요.
          </span>
        </p>

        <Button
          className={cn('px-40pxr rounded-full', 'mb:w-full')}
          variant="primary"
          size="large"
          onClick={handleGoHome}
        >
          홈페이지로 돌아가기
        </Button>
      </body>
    </html>
  )
}
